<template>
  <div
    class="space-y-3"
    role="status"
    :aria-label="ariaLabel"
  >
    <div
      class="px-3 py-4 rounded-xl border border-slate-200/80 dark:border-slate-700/80 space-y-2"
    >
      <span
        class="block h-3 w-24 mx-auto rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
      <span
        class="block h-7 w-28 mx-auto rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
    </div>

    <div class="flex items-center justify-center gap-2">
      <span
        v-for="n in 3"
        :key="`round-skel-${n}`"
        class="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
    </div>

    <span
      class="block h-9 w-full rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse"
    ></span>
  </div>
</template>

<script setup>
defineProps({
  ariaLabel: { type: String, default: "Loading" },
});
</script>
